/** 纯函数：避免测试环境拉取 layer-kit 全量依赖 */
export const computerImageLayerRatio = (
    layerWidth: number,
    layerHeight: number,
    imageWidth: number,
    imageHeight: number,
) => {
    const layerAspectRatio = layerWidth / layerHeight;
    const imageAspectRatio = imageWidth / imageHeight;

    let widthRatio: number;
    let heightRatio: number;
    let scale: number;

    if (imageAspectRatio >= layerAspectRatio) {
        heightRatio = 1;
        widthRatio = imageAspectRatio / layerAspectRatio;
        scale = imageHeight / (layerHeight * heightRatio);
    } else {
        widthRatio = 1;
        heightRatio = layerAspectRatio / imageAspectRatio;
        scale = imageWidth / (layerWidth * widthRatio);
    }

    return { widthRatio, heightRatio, scale };
};
